var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "expedient-insurers-container" },
    [
      _c(_setup.FormGeneratorComponent, {
        attrs: {
          context: _setup.context,
          schema: _setup.formSchema,
          fieldValues: _setup.parsedFormData,
        },
      }),
      _setup.gridConfiguration
        ? _c(_setup.LfGridComponent, {
            attrs: {
              gridConfiguration: _setup.gridConfiguration,
              itemData: _setup.expedientInsurers,
              toolbarOptions: _setup.toolbarItemsOptions,
              toolbarClick: _setup.onToolbarClick,
              commandClick: _setup.onCommandClick,
              contextMenuItems: _setup.contextMenuItems,
              exportName: _setup.texts.exportName,
            },
            on: {
              rowClick: _setup.onRowClick,
              contextMenuClicked: _setup.onContextMenuClicked,
            },
          })
        : _vm._e(),
      !_setup.isPortalUser
        ? _c(_setup.PromptDialogComponent, {
            attrs: {
              title: _setup.modalTitle,
              isOpened: _setup.openedPrompt,
              formSchema: _setup.parsedModalFormSchema,
              formFieldValues: _setup.modalFormData,
              context: _setup.contextModal,
              width: _setup.modalWidth,
            },
            on: { "execute-action": _setup.onExecuteAction },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }